import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import {
  RecommendedUsers,
  PageLoader,
  HomeSearch,
  Notification,
} from '../components';
import AppContext from '../context/AppContext';

import { pageAnimation } from '../animation';
import notificationApi from '../api/notification';
import useApi from '../hooks/useApi';

import defPic from '../assets/images/bg.jpg';
export default function Notifications() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    currentAccount,
    theme,
    isLoggedIn,
    isMember,
    hasLoaded,
    accountDetails,
    setSideNav,
    sideNav,
  } = useContext(AppContext);
  const getNotifications = useApi(notificationApi.getNotifications);
  useEffect(() => {
    if (hasLoaded) {
      if (!isLoggedIn) {
        navigate('/connect');
      } else if (!isMember) {
        navigate('/create-profile');
      } else {
      }
    }
  }, [isMember, isLoggedIn, hasLoaded]);

  useEffect(() => {
    if (accountDetails?.id) {
      getNotifications.request(accountDetails?.id);
    }
  }, [accountDetails?.id]);
  let notifications = getNotifications?.data?.notifications?.items;
  console.log('HERE ARE THE NOTIFICATIONS', notifications);
  return (
    <StyledNotification
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      theme_={theme}
    >
      {!accountDetails || !notifications ? (
        <PageLoader visible={true} />
      ) : (
        <>
          <div className="left">
            <div className="header">
              <span className="dp" onClick={() => setSideNav(!sideNav)}>
                <img src={accountDetails?.picture?.original?.url || defPic} />
              </span>

              <span>
                <h2>Notifications</h2>
              </span>
            </div>

            {notifications?.length > 0 ? (
              <div className="notifications">
                {notifications.map(
                  (notification, index) =>
                    (notification.__typename = 'NewFollowerNotification' && (
                      <Notification notification={notification} key={index} />
                    ))
                )}
              </div>
            ) : (
              <span className="no-notification">
                <h2>No Notications</h2>
              </span>
            )}
          </div>
          <div className="right">
            <HomeSearch />
            <RecommendedUsers />
          </div>
        </>
      )}
    </StyledNotification>
  );
}
const StyledNotification = styled(motion.div)`
  display: flex;
  flex-flow: row wrap;
  position: fixed;
  width: 80%;
  right: 0;
  top: 0;
  height: 100%;
  overflow-y: scroll;
  @media screen and (max-width: 900px) {
    position: absolute;
    width: 100%;
    padding-bottom: 15%;
  }
  .left {
    width: 60%;
    display: flex;
    flex-flow: column wrap;
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    clip-path: inset(0px -15px 0px 0px);
    .dp {
      display: none;
    }
    @media screen and (max-width: 900px) {
      width: 100%;
      .dp {
        display: block;
        border-radius: 50%;
        background: grey;
        width: 2rem;
        height: 2rem;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .header {
      position: sticky;
      top: 0;
      padding: 1rem 2rem;
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(15, 15, 15,0.8)' : 'rgb(255, 255, 255,0.8)'};
      @media screen and (max-width: 900px) {
        display: flex;
        gap: 1rem;
        align-items: center;
        padding: 0.8rem 1rem;
      }
      z-index: 2;
    }
  }
  .right {
    width: 40%;
    padding: 0rem 1rem;
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    position: sticky;
    top: 0;
    right: 0;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .notifications {
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    padding: 1rem 1rem;
    width: 100%;
    @media screen and (max-width: 900px) {
      padding: 0rem 0rem;
      gap: 0rem;
    }
  }
  .no-notification {
    display: flex;
    justify-content: center;
    padding: 3rem 0rem;
  }
`;
